import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import Header from './templates/header/Header';
import Navigation from './templates/nav/Nav';

// #if process.env.LOCAL === 'true'
// 
// sessionStorage.setItem(
//   'oidc.user',
//   JSON.stringify({
//     profile: { role: process.env.LOCAL_ROLES, warehouse_name: process.env.LOCAL_WAREHOUSE_NAME },
//   }),
// );
// 
// #endif

if (document.getElementsByTagName('header')[0]) {
  const root = ReactDOM.createRoot(document.getElementsByTagName('header')[0] as HTMLElement);
  root.render(
    <StrictMode>
      <Header />
    </StrictMode>,
  );
}
if (document.getElementsByTagName('nav')[0]) {
  const root = ReactDOM.createRoot(document.getElementsByTagName('nav')[0] as HTMLElement);
  root.render(
    <StrictMode>
      <Navigation />
    </StrictMode>,
  );
}
